export default __webpack_public_path__ + "search-icon-blue.2f57cd767222b6298083.png";